// RAM signal — detecta memória disponível pro device.
//
// Fonte primária: navigator.deviceMemory (Chromium-based — Tizen 5+,
// webOS 5+, Android, Web). Retorna GB arredondados pra escada {0.25, 0.5,
// 1, 2, 4, 8} pra preservar privacidade.
//
// Quando indisponível (Safari, Tizen <5, webOS <5), fallback em null —
// caller decide. Em capabilities, sem RAM signal o tier é estimado via
// CPU + plataforma.

export type RamTier = 'vlow' | 'low' | 'mid' | 'high' | 'ultra' | 'unknown'

export interface RamSignal {
  tier: RamTier
  /** GB reportados pelo browser. null quando deviceMemory indisponível. */
  gb: number | null
}

export function readRamSignal(): RamSignal {
  const nav = typeof navigator !== 'undefined' ? navigator : null
  const gb =
    nav && 'deviceMemory' in nav
      ? (nav as Navigator & { deviceMemory?: number }).deviceMemory ?? null
      : null

  if (gb === null) return { tier: 'unknown', gb: null }

  // Limiares calibrados pra TVs:
  // - vlow:  Tizen 2017 (1GB), webOS 3 (1.5GB)
  // - low:   TVs 2018-2019 (2GB)
  // - mid:   TVs 2020+ (3-4GB)
  // - high:  TV box premium / smart TV moderna (4-6GB)
  // - ultra: PC desktop (8GB+)
  let tier: RamTier
  if (gb < 1.5) tier = 'vlow'
  else if (gb < 2) tier = 'low'
  else if (gb < 4) tier = 'mid'
  else if (gb < 8) tier = 'high'
  else tier = 'ultra'

  return { tier, gb }
}
